import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../Components/Table/CustomTable';
// import ThreeStepsHeadingModal from '../Modal/ThreeStepsModal/ThreeStepsHeadingModal';
// import ThreeStepsCardDesignModal from '../Modal/ThreeStepsModal/ThreeStepsCardDesignModal';
import { Grid } from '@mui/material';
// import OffersCardDesignModal from '../Modal/OffersModal/CommonCardDesignModal';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { toast } from 'react-toastify';
// import OfferSection from './OffersPreview/OfferSection';
import PreviewComponent from '../../PreviewComponent/PreviewComponent';
import NextStepModal from '../Modal/NextStep/NextStepModal';
import NextStepForwardGold from '../BlogsPreview/NextStep/NextStepForwardGold';
import RecentStepsModal from '../Modal/RecentSteps/RecentStepsModal';
import RecentPosts from '../BlogsPreview/RecentSteps/RecentPosts';

const RecentStepSection = () => {


    const tableData = [
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },
        { title: 'The Best Gold', Content: 'Lorem Ipsum is simply dummy text of the...', document: "card.svg", status: "Pending" },

    ];
    // const tableHeadData = ['S.No', 'Title', 'Content', "Document", 'Status'];

    const permissions = JSON.parse(sessionStorage.getItem("permissions"));

    const [editCardsData, setEditCardsData] = useState(
        [
            { card_title: 'Card 1', card_content: 'Content 1', image: null },
            { card_title: 'Card 2', card_content: 'Content 2', image: null },
            { card_title: 'Card 3', card_content: 'Content 3', image: null },
            { card_title: 'Card 4', card_content: 'Content 4', image: null }
        ]
    );

    //   ================================================

    const role = sessionStorage.getItem("role")
    // csonole

    // const tableData = role === "superAdmin" || role === "management"
    //   ? [{ title: 'The Best Gold', secondtext: 'Staking Company', subtext: 'Lorem Ipsum is simply dummy text of the...', documents: "banner.jpg" }]
    //   : [];

    const tableHeadData = role === "superAdmin" || role === "management"
        ? ['S.No', 'Heading Title', 'Card Title','Creater Name', "Creater Role", "Approver Name", "Approver Role", "Rejector Name", "Rejector Role",  "Status"]
        : ['S.No', 'Heading Title', "content", 'Card Title', 'Status']






    const dispatch = useDispatch();

    const [responseTableData, setResponseTableData] = useState([])
    // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
    console.log(responseTableData, "responseTableDataresponseTableData")
    const { getBlogSectionById } = useSelector(state => state?.getBlogSectionById);
    const { addBlogSection } = useSelector(state => state?.addBlogSection);

    const { updateBlogSection } = useSelector(
        (state) => state?.updateBlogSection
    );

    const { deleteBlogSection } = useSelector(
        (state) => state?.deleteBlogSection
    );




    const { getAllBlogSectionsWithCreatorBySectionName } = useSelector(
        (state) => state?.getAllBlogSectionsWithCreatorBySectionName
    );

    const { getAllBlogSectionsBySectionNameBasedOnCreator } = useSelector(
        (state) => state?.getAllBlogSectionsBySectionNameBasedOnCreator
    );

    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")
    console.log(getAllBlogSectionsBySectionNameBasedOnCreator, "rowTableTAdatatattattat111111")

    const { addBlogSectionWithApproval } = useSelector(
        (state) => state?.addBlogSectionWithApproval
    );




    const { updateBlogSectionForReApproval } = useSelector(
        (state) => state?.updateBlogSectionForReApproval
    );


    const { approveBlogSection } = useSelector((state) => state?.approveBlogSection);
    const { rejectBlogSection } = useSelector((state) => state?.rejectBlogSection);




    useEffect(() => {
        const fetchData = async () => {
            if (role === "superAdmin" || role === "management") {

                const data1 = {
                    data: {

                        section_name: "recentPost" // "Touch" , "getInTouch"
                    },
                    method: "post",
                    apiName: `getAllBlogSectionsBySectionNameWithAllAuthUserDetails`,
                };

                const responseData = await dispatch(actions.GETALLBLOGSECTIONSWITHCREATORBYSECTIONNAME(data1));
                setResponseTableData(responseData?.payload)

            }

            else {

                const data1 = {
                    data: {
                        section_name: "recentPost" // "Touch" , "getInTouch"

                    },
                    method: "post",
                    apiName: `getAllBlogSectionsBySectionNameBasedOnCreator`,
                };

                const responseData = await dispatch(actions.GETALLBLOGSECTIONSBYSECTIONNAMEBASEDONCREATOR(data1));
                setResponseTableData(responseData?.payload)


            }
        }


        fetchData();
    }, [addBlogSection,approveBlogSection,rejectBlogSection,addBlogSectionWithApproval, deleteBlogSection, updateBlogSection, updateBlogSectionForReApproval]);

    useEffect(() => {
        const tempArr = [];
        if (role === "superAdmin" || role === "management") {
            getAllBlogSectionsWithCreatorBySectionName?.data?.map((data, index) => {
                return tempArr.push({
                    creatorName: data?.creator?.name || '--',
                    creatorRole: data?.creatorRole?.roleName || '--',

                    title: `${data?.heading} ${data?.sub_heading}` || '--',
                    // secondtext: data?.sub_heading || '--',
                    // subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    card_title: data?.additional_data?.card_design
                        ?.map(card => [`${card?.title} ${card?.cart_title_secondtext}`]) // Collects both values
                        .flat() // Flattens the array
                        .filter(title => title) // Removes undefined or null values
                        .join(", "),

                    // approval_status: data?.approval_status || "--"creatorName: data?.creator?.name || '--',
                    creatorRole: data?.creatorRole?.roleName || '--',
                    approverName: data?.approver?.name || '--',
                    approverRole: data?.approverRole?.roleName || '--',
                    rejectorName: data?.rejector?.name || '--',
                    rejectorRole: data?.rejectorRole?.roleName || '--',
                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"
                });
            });
            setRowTableData(tempArr);
        } else {
            getAllBlogSectionsBySectionNameBasedOnCreator?.data?.map((data, index) => {
                return tempArr.push({

                    title: `${data?.heading}${data?.sub_heading}` || '--',

                    // secondtext: data?.sub_heading || '--',
                    subtext: data?.content || '--',
                    section_id: data?.section_id || '--',
                    // approval_status: data?.approval_status || "--"
                    card_title: data?.additional_data?.card_design
                        ?.map(card => [`${card?.title} ${card?.cart_title_secondtext}`]) // Collects both values
                        .flat() // Flattens the array
                        .filter(title => title) // Removes undefined or null values
                        .join(", "),

                    approval_status: data?.approval_status
                        ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
                        : "--"

                });
            });
            setRowTableData(tempArr);

        }
    }, [getAllBlogSectionsBySectionNameBasedOnCreator, getAllBlogSectionsWithCreatorBySectionName]);


    console.log(rowTableData, "rowTableDatattattata")



    const handleTableDataDelete = async (id) => {


        const data1 = {
            data: {},
            method: "delete",
            apiName: `deleteBlogSection/${id}`,
        };
        const responseData = await dispatch(actions.DELETEBLOGSECTION(data1));
        if (responseData?.payload?.message === "Blog section soft deleted successfully.") {
            toast.success(responseData?.payload?.message)
        } else {
            toast.error(responseData?.payload?.message)

        }
    }

    // ==========================================================================

    return (
        <Grid container spacing={2}>

            <Grid item xs={12} sx={{ width: "100px" }}>
                <CustomTable
                    tableDelete={permissions?.ContentManagement?.Blog.delete}
                    // editData={editCardsData}
                    editModalName={RecentStepsModal}

                    tableView={true}
                    modalVeiwName={PreviewComponent}
                    sectionNameForApproveAndReject="BlogSection"


                    ModalPreviewComponent1={RecentPosts}
                    handleTableDataDelete={handleTableDataDelete}

                    section_name="recentPost"
                    tableEdit={permissions?.ContentManagement?.Blog.edit}
                    dataCreate={permissions?.ContentManagement?.Blog.add}
                    tableData={rowTableData} title="Recent Steps" tableHeadData={tableHeadData} modalName={RecentStepsModal} />

            </Grid>
        </Grid>
    )
}

export default RecentStepSection